import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useOutletContext, useSearchParams } from 'react-router-dom';

import { IUser, pageInfoState, userState } from '../../atoms';
import { ITabObject } from 'customTypes';
import Tab from '../../components/Tab';
import CustomForm from './setting7/customForm';

const CSetting7 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const userInfo = useRecoilValue<IUser>(userState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { userMenuList } = userInfo;
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList //
        ?.find(
          (el: ITabObject) =>
            el.mtCd === v.mtCd && //
            el.mdCd === v.mdCd &&
            el.mrCd === v.mrCd
        );
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = userMenuList.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <CustomForm formType='creport' />; // 보고서 양식지
        case '002':
          return <CustomForm formType='cdraft' />; // 기안 양식지
        case '003':
          return <CustomForm formType='attendance' />; // 근태 양식지
      }
    }
    return null;
  };

  return (
    <div className='contents'>
      <Tab
        tabList={newTabList || tabInfo.tabList} //
        currentTabMrCd={currentTabMrCd}
        setCurrentTabMrCd={setCurrentTabMrCd}
        onClickTab={onClickTab}
        size={size}
      />
      <div className='content-container oneColumn'>{renderPage()}</div>
    </div>
  );
};

export default CSetting7;
